var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ManagerInvite", {
        attrs: {
          companyBusinessName: _vm.companyBusinessName,
          companyId: _vm.companyId,
          managersUnlimited: _vm.managersUnlimited,
          accessAllowedManagersCount: _vm.accessAllowedManagersCount,
          activeManagersCount: _vm.activeManagersCount,
        },
        on: { openManagerAddonModal: _vm.openManagerAddonModal },
        model: {
          value: _vm.contractorDialog,
          callback: function ($$v) {
            _vm.contractorDialog = $$v
          },
          expression: "contractorDialog",
        },
      }),
      _vm.managerAddonPopup
        ? _c("ManagerAddonModal", {
            attrs: { company: _vm.company, currentUser: _vm.currentUser },
            on: {
              closeManagerAddonModal: _vm.closeManagerAddonModal,
              openManagerAddonModalAndCloseSubscriptionActionModalClose:
                _vm.openManagerAddonModalAndCloseSubscriptionActionModalClose,
            },
          })
        : _vm._e(),
      _c(
        "UiButton",
        {
          attrs: {
            disabled: _vm.isDisabled,
            size: _vm.size,
            variant: "blue",
            id: "inviteNewManager",
          },
          on: { click: _vm.showInviteModal },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return undefined
              },
              proxy: true,
            },
          ]),
        },
        [_c("span", [_vm._v("Invite Manager")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }